import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text, Box } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import {
    BaseWidget,
    WidgetMainText,
} from "app/pages/digital-marketing/monitor-and-protect/shared/components/widgets/base-widget";
import { InsightHeader } from "app/pages/digital-marketing/monitor-and-protect/shared/ui/typography/texts";

import { QuickBooks } from "../quick-books";

export const RecommendationsSection = () => {
    const translate = useTranslation();
    return (
        <Stack
            paddingX="40px"
            gap="32px"
        >
            <Box
                position="relative"
                height="160px"
                width="200px"
            >
                <BaseWidget
                    position="absolute"
                    width="170px"
                    padding="12px"
                    flexDirection="column"
                    top="30px"
                    gap="4px"
                    delay="800ms"
                >
                    <Flex
                        gap="2px"
                        alignItems="center"
                    >
                        <SWReactIcons
                            iconName="wand"
                            size="xs"
                            iconColor={colorsPalettes.carbon["200"]}
                        />
                        <Text
                            fontVariant="caption"
                            color={colorsPalettes.carbon["300"]}
                        >
                            {translate("monitor_and_protect.homepage.recommendations.recommendation")}
                        </Text>
                    </Flex>

                    <WidgetMainText
                        fontVariant="primaryItem"
                        color={colorsPalettes.carbon["400"]}
                    >
                        {translate("monitor_and_protect.homepage.recommendations.increase_bids")}
                    </WidgetMainText>
                </BaseWidget>
                <BaseWidget
                    position="absolute"
                    width="124px"
                    padding="6px"
                    height="auto"
                    top="88px"
                    right="0"
                    delay="1000ms"
                >
                    <QuickBooks />
                </BaseWidget>
            </Box>

            <InsightHeader
                delay="900ms"
                fontVariant="h6"
                color={colorsPalettes.carbon["400"]}
            >
                {translate("monitor_and_protect.homepage.recommendations.insight")}
            </InsightHeader>
        </Stack>
    );
};
